import { ArrowLeft, ArrowRight } from '@mui/icons-material';
import { Pagination, PaginationItem } from '@mui/material';
import { useEffect, useState } from 'react';
import '../../components/app/common.scss';
import useWindowDimensions from './WindowDimensions';

function CustomPagination({ pages , page = 1, onChange = (page) => {}}) {
    const [currentPage, setCurrentPage] = useState(page);
    const handleChange = (event, value) => {
        setCurrentPage(value);
        onChange(value);
    };
    useEffect(() => {
        setCurrentPage(page);
    }, [page]);

    const { width } = useWindowDimensions();
    const [maxPages] = useState(width <= 780 ? 1 : 10);
    const [siblings] = useState(width <= 780 ? 0 : 1);
    
    return (
        <div className='custom-pagination-wrp'>
            <div className='current-page'>Page {currentPage} of {pages}</div>
            <div className='pages-wrp'>
                <span>Page</span>
                <Pagination count={pages} page={currentPage} onChange={handleChange} siblingCount={siblings}
                    boundaryCount={maxPages}
                    renderItem={(item) => (
                        <PaginationItem
                            components={{ previous: ArrowLeft, next: ArrowRight }}
                            {...item}/>
                    )} />
            </div>
        </div>
    );
}

export default CustomPagination;